export default "__VITE_ASSET__5PCFRB9K__"